var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningMini = function SvgWarningMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M3.333 8a4.667 4.667 0 1 0 9.334 0 4.667 4.667 0 0 0-9.334 0ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm0 2.667c.368 0 .667.298.667.666v3.334a.667.667 0 0 1-1.334 0V5.333c0-.368.299-.666.667-.666Zm0 6.666A.667.667 0 1 0 8 10a.667.667 0 0 0 0 1.333Z",
    clipRule: "evenodd"
  })));
};
export default SvgWarningMini;